// extracted by mini-css-extract-plugin
module.exports = {"container":"RamadanActivitiesSection_container__TXNG4","illustrationContainer":"RamadanActivitiesSection_illustrationContainer__lZFOK","cta":"RamadanActivitiesSection_cta__cAwDT"};